export const TECHOPERATIONS_MODULE_NAME = "techOperationsPage";
export const EKOCROP_WEB_APP_SOURCE_SYSTEM_CODE = "internal.ekocrop.web_app";
